import React, { Fragment, useState } from "react";
import { find } from "lodash";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { Icon, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

function PageTitleDD(props) {
  const { ddItems: items } = props;
  const currentPagePath = window.location.pathname;
  const [ddIcon, setDDIcon] = useState("angledown");
  const history = useHistory();

  function onDDToggle(isOpen) {
    if (ddIcon === "angledown") {
      setDDIcon("angleup");
    } else {
      setDDIcon("angledown");
    }
  }

  function getCurrentPageLabel(currentPagePath) {
    return find(items, { path: currentPagePath })?.label;
  }

  function handleMenuItemClick(path) {
    history.push(path);
  }

  return (
    <Menu isLazy>
      <MenuButton
        onClick={onDDToggle}
        bg="transparent"
        border="none"
        sx={{
          span: {
            color: "gray.100",
          },
        }}
        p="0"
      >
        <span className={"title"}>{getCurrentPageLabel(currentPagePath)} </span>
        {ddIcon === "angleup" ? (
          <Icon as={FaAngleUp} ml={2} />
        ) : (
          <Icon as={FaAngleDown} ml={2} />
        )}
      </MenuButton>
      <MenuList>
        {items.map((item, index) => {
          if (currentPagePath === item.path) {
            return <Fragment key={item.id}></Fragment>;
          }
          return (
            <MenuItem
              key={item.id}
              onClick={() => handleMenuItemClick(item.path)}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}

export default PageTitleDD;
